<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { CardAdmin } from '@shared/ui/cards'

import CustomerStageComment from '../CustomerStageComment.vue'
import { useCustomerCommentsFeed } from '../../model/comments/customer-comments-feed.hook'

defineOptions({
  name: 'SectionCustomerComments',
})

const {
  refComments,
  isLoading,
  isLoadingMore,
} = useCustomerCommentsFeed()
</script>

<template>
  <CardAdmin
    title="All Comments"
    fullwidth
    class="section-customer-comments"
  >
    <div class="section-customer-comments__feed">
      <CustomerStageComment
        v-for="comment in refComments"
        :key="comment.id"
        :comment="comment"
      />
      <AppText
        v-if="isLoading || isLoadingMore"
        name="body2"
        color="slate-500"
      >
        Loading...
      </AppText>
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./SectionCustomerComments.scss" />
